export default __webpack_public_path__ + "8c91feafc18dccc015e0c506d9dff4f2.svg";